import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ResultPageModel } from '../../Core/SortingAndPaging/Models/ResultPageModel';
import { InstructionWorkInProgress } from '../../Models/Domains/Instructions/InstructionWorkInProgress';

declare var IS_RUNNING_IN_APP_POOL;

export class InstructionWorkInProgressClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(page: number, pageSize: number, customerId: number): Promise<ResultPageModel<InstructionWorkInProgress>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruction/InstructionWorkInProgress/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { page: page, pageSize: pageSize, customerId: customerId }

    return AjaxWrapper.get<ResultPageModel<InstructionWorkInProgress>, any>(url, data);
  }
}

